import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ResultSelectionService } from '../../services/result-selection.service';
import { ZipDownloadService } from '../../services/zip-download.service';
import { environment } from '../../../environments/environment';
import { DocumentDownloadService } from '../../services/document-download.service';
import { SearchResultsModel } from '../../models/search-results-model';
import { ConstantsService } from '../../services/constants.service';
import { FoldersService } from '../../services/folders.service';
import { DownloadRequest } from '../../models/download-req-model';

@Component({
  selector: 'app-download-dialog',
  templateUrl: './download-dialog.component.html',
  styleUrls: ['./download-dialog.component.css']
})
export class DownloadDialogComponent implements OnInit {

  @Input() downloadVisible: boolean = false;
  @Output() closeDialog = new EventEmitter();

  itemCount: number = 0;
  downloadCount: number = 0;
  docMax = 25;
  isDownloading = false;
  currentIndex: string;

  constructor(private zipSvc: ZipDownloadService,
    private selectionSvc: ResultSelectionService,
    private downloadDocSvc: DocumentDownloadService,
    private folderSvc: FoldersService,
    private constants: ConstantsService) {
    this.currentIndex = this.constants.indexEHD;
  }

  ngOnInit(): void {
    this.docMax = environment.download_files_max;
    this.itemCount = this.selectionSvc.getCount();
    this.selectionSvc.selectedCount$.subscribe(c => { this.itemCount = c; });
    this.selectionSvc.downloadableCount$.subscribe(d => { this.downloadCount = d; })
    this.folderSvc.selectedLibrary$.subscribe((l) => {
      this.currentIndex = l;
    });
  }

  executeClose() {
    this.closeDialog.emit();
  }

  executeDownload() {
    this.zipSvc.setIsDownloading(true);

    this.zipSvc.getFiles().subscribe({
      next: (docs) => {
        console.log('Final docs count:', docs.length);
        this.getAccessionNumbersToDownload(docs);
        this.closeDialog.emit();
      },
      error: (err) => {
        console.error('Error collecting files for download:', err);
        this.zipSvc.setIsDownloading(false);
      }
    });
  }

  // executeDownload() {
  //   this.zipSvc.setIsDownloading(true);
  //   // this.zipSvc.getFiles();
  //   let docs: SearchResultsModel[] = this.zipSvc.getFiles();
  //   this.getAccessionNumbersToDownload(docs);
  //   this.closeDialog.emit();
  // }

  getAccessionNumbersToDownload(items: SearchResultsModel[]) {

    // items.forEach(element => {
    //   console.log('AccessionNumber: ' + element.document?.AccessionNumber);
    //   console.log('IsPackageValue: ' + element.document?.ItemType);  
    // });

    let accessionNumbers: string[] = items
      .map(result => (result.document?.AccessionNumber))
      .filter((id): id is string => typeof id === "string");

    const finalList = this.getDistinctItemsForDownload(accessionNumbers, this.docMax)
    console.log('full list:', JSON.stringify(finalList));
    console.log('Original List', JSON.stringify(accessionNumbers));
    // console.log("final requested items", finalList.length);
    // console.log('accession count start: ', accessionNumbers.length);

    this.doDownload(finalList);
  }

  getDistinctItemsForDownload(items: string[], limit: number): string[] {
    const seen = new Set<string>();
    const distinct:string[] = [];

    for (const item of items){
      if(!seen.has(item)){
        seen.add(item);
        distinct.push(item);
      }

      if(distinct.length === limit) break;
    }

    return distinct;
  }

  doDownload(items: string[]) {
    console.log('download item count: ' + JSON.stringify(items.length));

    let docs: DownloadRequest = { accessionNumbers: items, indexId: this.currentIndex };

    this.downloadDocSvc.getDocuments(docs).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'documents.zip';
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        console.error('[downloaddialog] Download Error', err);
      }
    });
  }

  closeProgressDialog() {
    this.zipSvc.setIsDownloading(false);
  }

  hasLegacySelected() {
    const hasLegacy = this.selectionSvc.legacyItemsSelected();

    return hasLegacy;
  }
}
